exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1W4-SWaDoHR4AHifnFVokw{width:300px}html[dir] ._1W4-SWaDoHR4AHifnFVokw{background-color:\"[theme:white, default:#ffffff]\"}._32BxM1FO0jXY3xTW5lD3cr{-webkit-animation:none!important;animation:none!important}._1Yyx3wIEF7Ar8m3nTigMHF{max-height:470px;overflow-x:hidden}.bc9ijHYux-j6qNoG72WFd{overflow:hidden}._2q0n_nmrjXEqaJvNl5uf63{height:28px}html[dir=ltr] ._2q0n_nmrjXEqaJvNl5uf63{padding-left:14px}html[dir=rtl] ._2q0n_nmrjXEqaJvNl5uf63{padding-right:14px}._2pTYsSnXy019FsgSeuTpC0{font-size:12px;font-weight:400;color:\"[theme:themePrimary, default:#0078D7]\";line-height:1;display:inline-block}html[dir] ._2pTYsSnXy019FsgSeuTpC0{padding-top:8px}", ""]);

// exports
exports.locals = {
	"callout": "_1W4-SWaDoHR4AHifnFVokw",
	"animationStop": "_32BxM1FO0jXY3xTW5lD3cr",
	"scrollContainer": "_1Yyx3wIEF7Ar8m3nTigMHF",
	"recipientCollection": "bc9ijHYux-j6qNoG72WFd",
	"suggestedContactsHeaderBox": "_2q0n_nmrjXEqaJvNl5uf63",
	"suggestedContactsText": "_2pTYsSnXy019FsgSeuTpC0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":{"orderedValues":false}}!./node_modules/postcss-loader/lib?{"plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./obj/controls/owa-readwrite-recipient-well/lib/components/FindRecipientResult.scss
// module id = 3394
// module chunks = 2 3